import react, { useState } from 'react';
import Newgrad from './Newgrad'

import {Switch, Route, Redirect, withRouter, NavLink} from 'react-router-dom';

const Main = (props) => {
  return (
    <>
      <Newgrad/>
    </>
  );
}

export default withRouter(Main);
//export default Main;
